module.exports = __webpack_public_path__ + "static/media/navigate-right.7fa3d5e5.svg";